/**
 * @requires Overlay
 */
class PhotoViewer {

    constructor() {
        if (!Overlay) return;

        this.container = document.querySelector('.photoviewer');

        if (!this.container) return;

        this.placeholderImage = this.container.querySelector('img');
        this.overlay = new Overlay(this.container);

        this.anchorsSelector = '[href$=".jpg"], [href$=".jpeg"], [href$=".png"], [href$=".gif"]';

        this.navigationKeys = [
            'ArrowLeft',
            'ArrowRight'
        ];

        this.registerEvents();
    }


    /**
     * Register events
     */
    registerEvents() {
        document.body.addEventListener('click', delegate(this.anchorsSelector, (e) => {
            e.preventDefault(e.delegateTarget);
            this.openImage(e.delegateTarget);
        }));

        document.addEventListener('keydown', (e) => {
            if (!this.container.matches('.overlay--opened') || this.navigationKeys.indexOf(e.key) < 0) return;

            let currentImage = this.container.querySelector('img');
            let currentOpener = document.querySelector('.photoviewer-currentimage');
            let imageGroup = currentOpener.closest('[data-photoviewer-group], .gallery');

            let imageGroupAnchors;
            let currentIndex;
            let imageToOpen;

            if (!imageGroup) return;

            imageGroupAnchors = imageGroup.querySelectorAll(this.anchorsSelector);

            if (!imageGroupAnchors) return;

            imageGroupAnchors = Array.prototype.slice.call(imageGroupAnchors);
            currentIndex = imageGroupAnchors.indexOf(currentOpener);

            imageToOpen = (e.key == 'ArrowRight') ? imageGroupAnchors[currentIndex + 1] : imageGroupAnchors[currentIndex - 1];

            if (!imageToOpen) return;

            this.closeImage(currentOpener);
            this.openImage(imageToOpen);
        });
    }


    /**
     * Open image
     * @param {Element} openerElement
     */
    openImage(openerElement) {
        if (!this.placeholderImage) {
            this.placeholderImage = new Image();
            this.container.querySelector('.photoviewer-wrapper').appendChild(this.placeholderImage);
        } else {
            this.placeholderImage.src = '';
        }

        this.placeholderImage.src = openerElement.href;
        openerElement.classList.add('photoviewer-currentimage');

        this.container.classList.add('photoviewer--loading');

        this.overlay.open(this.container);

        this.container.addEventListener('overlay:close', (eventData) => {
            this.closeImage(openerElement);
        });

        this.waitForImageToLoad(this.placeholderImage).then(() => {
            this.placeholderImage.parentNode.removeAttribute('style');
            this.container.classList.remove('photoviewer--loading');
        });
    }


    /**
     * Close image
     * @param {Element} openerElement
     */
    closeImage(openerElement) {
        openerElement.classList.remove('photoviewer-currentimage');
    }


    /**
     * Wait for image to load
     * @param {Image} imageElement
     * @return {Promise}
     */
    waitForImageToLoad(imageElement){
        return new Promise(function(resolve) {
            imageElement.onload = resolve;
        });
    }

};


let photoviewer = (function() {
    new PhotoViewer();
})();
